module.exports = __webpack_public_path__ + "static/media/mobile-product-logo-3.49769cd5.svg";